import { ImageAsset } from "res/";

export default function BillerDropdownItem({ biller, controllers, onChange }) {
    const { set } = controllers;
    const onClick = evt => {
        set({ value: biller.name, dropdown: false });
        
        if(onChange instanceof Function){
            onChange(biller.name);
        }
    };

    return (
        <div className="row-main-content flex-container flex-horizontal align-center clickable" onClick={ onClick }>
            <div className="logo-container set-width">
                <ImageAsset id={ biller.logo } className="logo-icon" />
            </div>

            <div className="biller-info-container flex-width">
                <p className="main-text"><span data-point={"biller_drop_down_"+biller.id}>{ biller.name }</span></p>
            </div>
        </div>
    );
}